import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission' // permission control
import * as echarts from 'echarts'
import axios from 'axios'
import 'animate.css';
import '@/assets/ttf/index.css';

Vue.prototype.$echarts = echarts;
Vue.prototype.axios = axios
import '@/styles/index.scss' // global css
import '@/styles/mycss.scss' // 自定义公共样式
import '@/styles/myvar.scss' // css变量引入
import '@/styles/vant.css' // vant样式引入
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import currentTime from './utils/currentTime.js';
Vue.prototype.$currentTime = currentTime;
Vue.config.productionTip = false

import AudioVisual from "vue-audio-visual";
Vue.use(AudioVisual);

import dataV from '@jiaminghi/data-view';

import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.pm";
import "leaflet.pm/dist/leaflet.pm.css";
Vue.L = Vue.prototype.$L = L;
import local from "@/utils/local";
Vue.LocalStor = Vue.prototype.$LocalStor = local;


/* leaflet icon || leaflet 图标引入*/
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
import  "@/assets/js/leaflet-tilelayer-colorizr.js";

// esayPlayer视频组件注册
// import EasyPlayer from "@easydarwin/easyplayer";
// Vue.component("EasyPlayer", EasyPlayer);

//自定义组件注册
import topBar from "@/components/topBar";
Vue.component("topBar", topBar);
import box from "@/components/box";
Vue.component("box", box);
import angle from "@/components/angle";
Vue.component("angle", angle);
import displacement from "@/components/displacement";
Vue.component("displacement", displacement);
import mydetails from "@/components/mydetails";
Vue.component("mydetails", mydetails);
import easyplayer from "@/components/easyplayer";
Vue.component("easyplayer", easyplayer);

import { Picker } from 'vant'
Vue.use(Picker);

// VoIP 通话通知组件（全局注册，切换页面后仍存在）
import VoipCallNotification from "@/components/VoipCallNotification";
Vue.component("VoipCallNotification", VoipCallNotification);


Vue.use(dataV);
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
